import { actions as collection } from '@/plugins/Collection'

export default collection.toEnumOptions([
  'None',
  'Monthly',
  'Quarterly',
  'Every Six Months',
  'Annually',
  'On Redemption'
])
